import React from "react";
import TollDetailReport from "./components/TollDetailReport";

function App() {
  return <TollDetailReport />
}

export default App;
